export default __webpack_public_path__ + "static/media/Expand.f9ad0578.svg";